import classNames from "classnames";

export const wrapper = classNames("w-full","p-4","flex","items-center","justify-center");
export const button = classNames(
    // Mobile
    "mobile:w-72",
    "mobile:h-10",
    "mobile:text-base",
    "mobile:font-semibold",
    "mobile:mt-2",
    // Tablet
    "tablet:w-64",
    "tablet:h-12",
    "tablet:text-xl",
    "tablet:font-normal",
    "tablet:mt-5",
    // All
    "bg-primary",
    "text-white",
    "rounded-lg",
    "z-40"
);